import React from "react";
import { FreeTrialFlow } from "@/features/free-trial";

/**
 * FreeTrialPage - 무료체험 신청 페이지
 */
export const FreeTrialPage = () => {
  return <FreeTrialFlow />;
};
